import React, { useState } from "react";
import {
  Grid,
  IconButton,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";
import Card from "../../StyledComponents/Card/Card";
import CardHeader from "../../StyledComponents/Card/CardHeader";
import CardText from "../../StyledComponents/Card/CardText";
import { makeStyles } from "@material-ui/styles";
import { ArrowBack, Error } from "@mui/icons-material";
import { dashboardStyle } from "../Invoices/Components/InvoiceDetails/style";
import { useNavigate } from "react-router-dom";
import GetInvoiceTable from "./reportTables/GetInvoiceTable.js";
import PoTable from "./reportTables/PoTable.js";
import { Tabs, Tab } from "@mui/material";
import PoBasedTable from "./reportTables/PoBasedTable.js";
import NoCompilanceBased from "./reportTables/NoCompilanceBased.js";
import PendingInvoiceTableA1 from "./PendingInvoiceTableA1.js";
import PendingInvoiceTableA2 from "./PendingInvoiceTableA2_v2.js";

const useStyles = makeStyles(dashboardStyle);
const commentBox = {
  fontFamily: "DM Sans,sans-serif",
  fontWeight: "400",
  fontSize: "0.875rem",
  width: "100%",
  border: "1px solid #b4b4b4",
  borderRadius: "2px",
  resize: "none",
  overflow: "hidden",
  outline: "none",
  height: "40px",
  marginTop: "1px",
  color: "black",
};
const headersPOCompilance = [
  { label: "Invoice No", key: "invoiceNo" },
  { label: "Vendor Name", key: "vendorName" },
  { label: "Submitted By", key: "submittedBy" },
  { label: "Submission Date", key: "submissionDate" },
  { label: "Invoice Date", key: "invoiceDate" },
  { label: "Sum Invoice Amount", key: "sumInvoiceAmount" },
  {label:"Invoice Type", key:"invoiceType"},
  { label: "Person Name", key: "personName" },
  { label: "Due Days", key: "dueDays" },
  { label: "Pending Days", key: "pendingDays" },
  { label: "Pending With", key: "pendingWith" },
];
const headersPOBased = [
  { label: "Pending With", key: "pendingWith" },
  { label: "Person Name", key: "personName" },
  { label: "Submitted By", key: "submittedBy" },
  { label: "Vendor Name", key: "vendorName" },
  { label: "Invoice No Count", key: "invoiceNoCount" },
];

export default function PendingInvoice() {
  const classes = useStyles();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sendloader, setSendloader] = useState(false);
  const [countNo, setCountNo] = React.useState(1);
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div>
      {" "}
      <>
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={sendloader}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Card style={{ marginLeft: "20px" }}>
          <div>
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              start
              style={{ marginBottom: "2%" }}
            >
              <Tab label="Pending Invoices A1" />
              <Tab label="Pending Invoices A2" />
            </Tabs>
            {/* {value === 0 && ( */}
            <div style={{ display: value === 0 ? 'block' : 'none' }}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <PendingInvoiceTableA1
                  loading={loading}
                  setCountNo={setCountNo}
                  header={headersPOCompilance}
                  data1={data1}
                  dropdownValue={"InvoiceStatus"}
                  setData1={setData1}
                  setLoading={setLoading}             
                />
              </Grid>
              </div>
            {/* )} */}
            {/* {value === 1 && ( */}
            <div style={{ display: value === 1 ? 'block' : 'none' }}>
              <PendingInvoiceTableA2
                loading={loading}
                setCountNo={setCountNo}
                header={headersPOBased}
                data={data}
                dropdownValue={"InvoiceStatus"}
                setData={setData}
                setLoading={setLoading}             
              />
            {/* )} */}
            </div>
          </div>
        </Card>
      </>
    </div>
  );
}
